import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { UserImageModelInstance } from 'src/store/_models/userImage';

type WithActiveProductProps<P> = P & {
  activeProduct: UserImageModelInstance;
};

type withoutActiveProductProps<P> = Omit<P, 'activeProduct'>;

export function withActiveProduct<P extends object>(Component: React.ComponentType<WithActiveProductProps<P>>) {
  return observer((props: withoutActiveProductProps<P>) => {
    const {
      project: { activeProduct },
    } = useStore();
    if (activeProduct) {
      const newComponentProps = {
        ...props,
        activeProduct: activeProduct,
      } as WithActiveProductProps<P>;
      return <Component {...newComponentProps} />;
    } else {
      return null;
    }
  });
}
